import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lg:container lg:mx-auto mt-12" }
const _hoisted_2 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-y-8 gap-x-0 lg:gap-x-8 mt-8" }
const _hoisted_3 = { class: "col-span-2 order-2 lg:order-1" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-y-8" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h2", { class: "text-red-500 mb-2" }, "BEETS")
], -1)
const _hoisted_6 = { class: "px-1 lg:px-0" }
const _hoisted_7 = { class: "mb-4 px-1 lg:px-0" }
const _hoisted_8 = { class: "order-1 lg:order-2 px-1 lg:px-0 pt-16" }
const _hoisted_9 = { class: "pt-2" }
const _hoisted_10 = { class: "mt-24 mb-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BeetsLBPChart = _resolveComponent("BeetsLBPChart")
  const _component_BeetsLBPStatCards = _resolveComponent("BeetsLBPStatCards")
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")
  const _component_LBPTradeCard = _resolveComponent("LBPTradeCard")
  const _component_LBPTable = _resolveComponent("LBPTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_BeetsLBPChart, {
              loading: _ctx.loadingTokenPrices || _ctx.loadingPool,
              "lbp-token-name": _ctx.lbpTokenName,
              "lbp-token-address": _ctx.lbpTokenAddress,
              "lbp-pool-id": _ctx.lbpPoolId,
              "lbp-end-time": _ctx.lbpEndTime,
              "lbp-start-time": _ctx.lbpStartTime,
              "token-prices": _ctx.tokenPrices,
              "usdc-address": _ctx.usdcAddress,
              "weight-step": _ctx.lbpWeightStep,
              "time-step": _ctx.lbpTimeStep,
              pool: _ctx.pool
            }, null, 8, ["loading", "lbp-token-name", "lbp-token-address", "lbp-pool-id", "lbp-end-time", "lbp-start-time", "token-prices", "usdc-address", "weight-step", "time-step", "pool"])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_BeetsLBPStatCards, {
              pool: _ctx.pool,
              "lbp-token-address": _ctx.lbpTokenAddress,
              "lbp-token-name": _ctx.lbpTokenName,
              "lbp-token-starting-amount": _ctx.lbpTokenStartingAmount,
              "usdc-address": _ctx.usdcAddress,
              "lbp-end-time": _ctx.lbpEndTime,
              "lbp-start-time": _ctx.lbpStartTime,
              loading: _ctx.loadingPool,
              "lbp-pool-id": _ctx.lbpPoolId,
              "is-before-lbp-start": _ctx.isBeforeLbpStart,
              onLbpStateChange: _ctx.handleLbpStateChange
            }, null, 8, ["pool", "lbp-token-address", "lbp-token-name", "lbp-token-starting-amount", "usdc-address", "lbp-end-time", "lbp-start-time", "loading", "lbp-pool-id", "is-before-lbp-start", "onLbpStateChange"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          (_ctx.appLoading || _ctx.loadingTokenLists)
            ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                key: 0,
                class: "h-96"
              }))
            : (_openBlock(), _createBlock(_component_LBPTradeCard, {
                key: 1,
                "lbp-token-name": _ctx.lbpTokenName,
                "lbp-token-address": _ctx.lbpTokenAddressFormatted,
                "usdc-address": _ctx.usdcAddressFormatted,
                "swap-enabled": _ctx.swapEnabled,
                onOnTx: _ctx.onNewTx
              }, null, 8, ["lbp-token-name", "lbp-token-address", "usdc-address", "swap-enabled", "onOnTx"]))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode(_component_LBPTable, {
        "lbp-token-name": _ctx.lbpTokenName,
        "lbp-token-address": _ctx.lbpTokenAddress,
        "lbp-pool-id": _ctx.lbpPoolId
      }, null, 8, ["lbp-token-name", "lbp-token-address", "lbp-pool-id"])
    ])
  ]))
}